export type ContentShareResult = "shared" | "cancelled" | "clipboard" | "prompt";
export type ContentShareFailureStage = "native-share" | "clipboard";

export type ContentShareServices = {
    share?: (data: ShareData) => Promise<void>;
    writeText?: (text: string) => Promise<void>;
    prompt?: (message: string, defaultValue: string) => string | null;
    report?: (error: unknown, stage: ContentShareFailureStage) => void;
};

export function normalizeContentShareTitle(title: string): string {
    const withoutBrand = title.replace(/\s*\|\s*SmartGuide\s*$/i, "").trimEnd();
    return withoutBrand.length > 0 ? withoutBrand : title.trimEnd();
}

export function normalizeContentShareUrl(rawUrl: string, origin: string): string {
    return new URL(rawUrl, origin).toString();
}

export async function shareContentLink(
    title: string,
    url: string,
    services: ContentShareServices
): Promise<ContentShareResult> {
    const shareTitle = normalizeContentShareTitle(title);

    if (services.share) {
        try {
            await services.share({
                title: shareTitle,
                text: shareTitle.length > 0 ? `${shareTitle} ` : " ",
                url
            });
            return "shared";
        } catch (error) {
            if (_isAbortError(error)) {
                return "cancelled";
            }

            services.report?.(error, "native-share");
        }
    }

    if (services.writeText) {
        try {
            await services.writeText(url);
            return "clipboard";
        } catch (error) {
            services.report?.(error, "clipboard");
        }
    }

    services.prompt?.("Copy this link", url);
    return "prompt";
}

function _isAbortError(error: unknown): boolean {
    return typeof error === "object" && error !== null && "name" in error && error.name === "AbortError";
}
